import axios from "axios";
export default axios.create({
    headers: {
        'Authorization': process.env.VUE_APP_REG_API_KEY,
    }
})

